import React from 'react';
import styles from 'styles/components/footers/printFooter.css';
import ovationtix_logo from 'images/ovationtix_logo.png';

const PrintFooter = () => (
  <footer className={styles.printFooter}>
    <h6 className={styles.credits}>
      Powered by:
      <div className={styles.creditsImage}>
        <img src={ovationtix_logo} alt="Ovationtix.com"/>
      </div>
    </h6>
  </footer>
);

export default PrintFooter;



// WEBPACK FOOTER //
// ./src/scripts/components/footers/PrintFooter.js